import React from "react";

function SubscriptionExpiredModal({ onGoToBilling }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-zinc-950/80 p-4 backdrop-blur-sm">
      <div
        className="w-full max-w-md rounded-2xl border border-zinc-800 bg-zinc-900 p-6 shadow-xl"
        role="dialog"
        aria-modal="true"
        aria-labelledby="subscription-expired-title"
      >
        <p className="text-xs font-medium uppercase tracking-wider text-amber-400">
          Trial ended
        </p>
        <h2 id="subscription-expired-title" className="mt-2 text-xl font-bold text-white">
          Subscribe to continue
        </h2>
        <p className="mt-3 text-sm leading-relaxed text-zinc-400">
          Your 30-day free trial has ended. Subscribe to Ghost Inbox Pro to keep using your
          account. Online payment is coming soon.
        </p>
        <div className="mt-6 flex flex-col gap-3 sm:flex-row">
          <button
            type="button"
            onClick={onGoToBilling}
            className="flex-1 rounded-lg bg-emerald-500 px-4 py-2.5 text-sm font-semibold text-zinc-950 hover:bg-emerald-400"
          >
            View billing
          </button>
        </div>
      </div>
    </div>
  );
}

export default SubscriptionExpiredModal;
